import {
    Commit,
    Dispatch,
} from 'vuex';
import i18n from '@app/localization/i18n';
import {
    ZendeskMetaDataFlags,
    initializeHelpBot,
    openHelp,
    setupHelpShownCallback,
    setupHelpHiddenCallback,
    setZenDeskContextHelpKey,
    setZendeskFlags,
} from '@modules/help';
import StoreUtil from '@store/StoreUtil';

export const SET_IS_HELP_VISIBLE = 'SET_IS_HELP_VISIBLE';
export const SET_HELP_KEY = 'SET_HELP_KEY';

export interface IHelpState {
    isHelpVisible: boolean;
    setHelpKey: string;
}

function defaultState(): IHelpState {
    return {
        isHelpVisible: false,
        setHelpKey: '',
    };
}

export default {
    namespaced: true,

    state: defaultState(),

    mutations: {
        [SET_IS_HELP_VISIBLE]: StoreUtil.createSimpleMutator('isHelpVisible'),
        [SET_HELP_KEY]: StoreUtil.createSimpleMutator('setHelpKey'),
    },

    actions: {
        showHelp({ commit, dispatch }: { commit: Commit, dispatch : Dispatch }, options: { shouldHideOnClose?: boolean }) {
            const loadingTimeoutText = i18n.t('pam.zendeskLoading.contactUs');
            setupHelpShownCallback(() => dispatch('markHelpAsShown'));
            setupHelpHiddenCallback(() => dispatch('markHelpAsHidden'));
            openHelp(options?.shouldHideOnClose, loadingTimeoutText);
            commit(SET_IS_HELP_VISIBLE, true);
        },
        markHelpAsShown({ commit }: { commit: Commit }): void {
            commit(SET_IS_HELP_VISIBLE, true);
        },
        markHelpAsHidden({ commit }: { commit: Commit }): void {
            commit(SET_IS_HELP_VISIBLE, false);
        },
        initializeHelpBot(_: { commit: Commit }, options: { openHidden?: boolean }) {
            initializeHelpBot(options);
        },
        setHelpKey({ commit }: { commit: Commit }, { path }: { path: string }): void {
            commit(SET_HELP_KEY, path);
            setZenDeskContextHelpKey(path);
        },
        registerZendeskFlags(_: { commit: Commit }, flags: ZendeskMetaDataFlags) {
            setZendeskFlags(flags);
        },
    },
};
